@if (label) {
  <span class="form-control-label">
    {{ label }}
  </span>
}
<p-select
  [filter]="true"
  filterBy="label, value"
  [options]="options"
  [(ngModel)]="weightUnit"
  (onChange)="onChange($event)"
>
</p-select>
